<div class="container" *ngIf="restaurant" [class.scrolled]="search != ''">
  <app-header
    [title]="restaurant.name"
    [description]="restaurant.description"
    [imageLogoUrl]="restaurant.imageLogoUrl"
    [imageUrl]="restaurant.imageUrl"
    [aboutRestaurant]="restaurant.about"
    [scrolled]="search != ''"
  ></app-header>

  <div class="content">
    <div class="content-field">
      <div class="form-field">
        <mat-icon class="icon-search" svgIcon="search"></mat-icon>
        <input
          type="text"
          [(ngModel)]="search"
          [placeholder]="'RESTAURANTS.SEARCH_RESTAURANT' | translate"
          (input)="filterProducts()"
        />
        <mat-icon
          *ngIf="search"
          class="icon-clear"
          (click)="cancelSearch()"
          svgIcon="close"
        ></mat-icon>
      </div>

      <button *ngIf="search" class="btn-cancel" (click)="cancelSearch()">
        {{ 'BUTTONS.CANCEL' | translate }}
      </button>
    </div>

    <div class="content-menu">
      <h3 *ngIf="search != ''">{{ 'RESTAURANTS.CHECKOUT_MENU' | translate }}</h3>

      <!-- CATEGORIAS -->
      <div class="categories">
        @for (item of listCategories; track item) {
          <button
            class="btn-category"
            (click)="setCategory(item)"
            [class.activate]="selectedCategory === item"
          >
            {{ item }}
          </button>
        }
      </div>

      <!-- PRODUTOS DA CATEGORIA ATIVA -->
      <div class="products">
        @if (isLoadingProducts) {
          <app-empty-state
            [title]="'SEARCH_FIELD.LOADING' | translate"
            [description]="'SEARCH_FIELD.LOADING_DESCRIPTION' | translate"
          ></app-empty-state>
        } @else {
          @for (item of filteredProducts; track item) {
            <app-product-card
              [id]="item.documentId || item.id"
              [title]="item.name"
              [description]="item.description"
              [price]="item.price/100"
              [imageUrl]="item.imageUrl"
              [isFavorite]="item.isFavorite ?? false"
              [productData]="item"
            ></app-product-card>
          } @empty {
            <app-empty-state
              [title]="'SEARCH_FIELD.NO_RESULTS_FOUND' | translate"
              [description]="'SEARCH_FIELD.NO_RESULTS_FOUND_PLATE' | translate"
            ></app-empty-state>
          }
        }
      </div>
    </div>
  </div>
</div>
